import BlRatingAv from './BlRatingAv.vue'
BlRatingAv.install = function(Vue) {
  Vue.component(BlRatingAv.name, BlRatingAv)
}
export default BlRatingAv
